import { DiseaseTreatment } from '../../common/_models/diseases/disease';
import { FieldActivity } from '../../common/_models';

export class UIRiskDegree {
  zoneId: number;
  zoneName: string;
  pathogenName: string;
  pathogenNameTranslated: string;
  probabilityOfAttack: string;
  probabilityOfAttackIndex: number;
  date: any;
  risk: any;
  primaryRisk: any;
  secondaryRisk: any;
  protection: any;
  riskColor: string;
  protectionColor: string;
  riskStatus: string;
  protectionStatus: string;
  fieldActivities: Array<FieldActivity>;
  externalSource: string;
  riskColorPrimary: string;
  riskStatusPrimary: string;
  riskColorSecondary: string;
  riskStatusSecondary: string;
  probabilityOfAttackPrimary: string;
  probabilityOfAttackIndexPrimary: number;
  protectionTreatments: Array<DiseaseTreatment>;
  consistency?: boolean;
  riskType: string;
  identification?: number;

  constructor() {
    this.zoneId = null;
    this.zoneName = null;
    this.pathogenName = null;
    this.pathogenNameTranslated = null;
    this.probabilityOfAttack = null;
    this.probabilityOfAttackIndex = null;
    this.date = null;
    this.risk = null;
    this.primaryRisk = null;
    this.secondaryRisk = null;
    this.protection = null;
    this.riskColor = null;
    this.protectionColor = null;
    this.riskStatus = null;
    this.protectionStatus = null;
    this.fieldActivities = [];
    this.externalSource = null;
    this.riskColorPrimary = null;
    this.riskStatusPrimary = null;
    this.riskColorSecondary = null;
    this.riskStatusSecondary = null;
    this.probabilityOfAttackPrimary = null;
    this.probabilityOfAttackIndexPrimary = null;
    this.riskType = null;
    this.protectionTreatments = null;
    this.consistency = null;
    this.identification = null;
  }
}
